import ExtensibleError from '@jira/platform__utils-extensible-error/src/index.tsx';

/**
 * Custom error class for access loss scenarios (e.g., 403 permission errors).
 * Used to identify errors that are expected business scenarios and should skip Sentry.
 */
export class PolarisAccessLossError extends ExtensibleError {
	name = 'PolarisAccessLossError';
}
